import { CONFLUENCE_GENERATOR_ID, JIRA_GENERATOR_ID } from '../../constants';
import { IconType } from '../../../constants';
import extractUrlIcon from './extract-url-icon';
import { extractTitle } from '@atlaskit/link-extractors';
var extractProviderIcon = function extractProviderIcon(data) {
  if (!data) {
    return undefined;
  }
  var generator = data.generator;
  var provider = generator === null || generator === void 0 ? void 0 : generator['@id'];
  var icon = generator === null || generator === void 0 ? void 0 : generator.icon;
  var label = (generator === null || generator === void 0 ? void 0 : generator.name) || extractTitle(data);
  if (provider === CONFLUENCE_GENERATOR_ID) {
    return {
      icon: IconType.Confluence,
      label: label || 'Confluence'
    };
  }
  if (provider === JIRA_GENERATOR_ID) {
    return {
      icon: IconType.Jira,
      label: label || 'Jira'
    };
  }
  return extractUrlIcon(icon, label);
};
export default extractProviderIcon;